import React, { FC, useRef, useEffect } from 'react';
import { Box } from '@mui/material';
import StyledBox from 'views/rebranded-module/deals-module/DealDetailsViewV2/components/DealWigdetSection/DealWigdetSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import {
  FlashSaleSection,
  DiscountSection,
  MobileAppExclusiveDealSection,
  TourPackageWidgetWrapper,
} from 'views/rebranded-module/deals-module/DealDetailsViewV2/components';
import { TourFootNote } from 'views/rebranded-module/common/components';
import { NewMainWidgetWrapper } from 'views/rebranded-module/common/components/Logical/NewMainWidgetWrapper';
import { RENTAL_WIDGET } from 'lib/utils/mainWidgetConstants';
import { DEAL_TYPES } from 'views/common/utils/constants';

interface DealWigdetSectionProps {
  deal: any;
  rentalWidgetInit: any;
  dealTours: any;
  handleShowActionBar: (value: boolean) => void;
}

const DealWigdetSection: FC<DealWigdetSectionProps> = (props) => {
  const { deal, rentalWidgetInit, dealTours, handleShowActionBar } = props;
  const widgetRef = useRef<HTMLDivElement | null>(null);
  const content = useContent('DealDetailsPage');
  const isAppExclusiveDeal = () => {
    let isBrowserWebView = false;
    if (typeof window !== 'undefined') {
      if (window.navigator.userAgent.indexOf('- ER -') === -1)
        isBrowserWebView = true;
    }
    return isBrowserWebView && deal.mobile_app_exclusive;
  };
  const scrollCallBack = (entries) => {
    if (entries[0].isIntersecting) {
      handleShowActionBar(false);
    } else {
      handleShowActionBar(true);
    }
  };
  const isTourDeal = () =>
    [DEAL_TYPES.TOUR, DEAL_TYPES.TOUR_WITH_OPERATIONAL_DAYS].includes(
      deal.deal_type.sym_id,
    );
  useEffect(() => {
    const observer = new IntersectionObserver(scrollCallBack, {
      threshold: 0.7,
    });
    if (widgetRef.current) {
      observer.observe(widgetRef.current);
    }
    return () => {
      // disconnect the observer when the component unmounts
      observer.disconnect();
    };
  }, [widgetRef]);

  return (
    <StyledBox id="deal-offer">
      {/* Flash Sale deal */}
      <Box className="DHWidgetAndFlashContainer">
        {deal.flash_sale_enabled && (
          <Box className="DWSFlashsaleContainer">
            <FlashSaleSection
              flashSaleEndTime={deal.flash_sale_end_time}
              flashSaleText={deal.flash_sale_display_text}
              disabled={deal.sold_out}
            />
          </Box>
        )}
        <Box className="DHWidgetContainer">
          {/* Discount */}
          <DiscountSection deal={deal} disabled={deal.sold_out} />
          <Box ref={widgetRef}>
            {isTourDeal() ? (
              <TourPackageWidgetWrapper
                dealTours={dealTours}
                deal={{
                  ...deal,
                  disabled: deal.sold_out || isAppExclusiveDeal(),
                }}
              />
            ) : (
              <NewMainWidgetWrapper
                widgetType={RENTAL_WIDGET}
                vertical
                isDealWidget
                shouldHideTitle
                actionButtonCustomLabel={
                  deal.sold_out
                    ? content.soldOutBtnLabel
                    : content.searchNowBtnLabel
                }
                rentalWidgetInitData={rentalWidgetInit}
                disabled={deal.sold_out || isAppExclusiveDeal()}
                reservationData={{
                  deal_id: deal.id,
                  vehicles_count: deal.min_motorcycles_number,
                }}
              />
            )}
          </Box>
        </Box>
      </Box>
      {isTourDeal() && (
        <Box mt={3}>
          <TourFootNote />
        </Box>
      )}
      <Box mt={3}>
        {isAppExclusiveDeal() && <MobileAppExclusiveDealSection />}
      </Box>
    </StyledBox>
  );
};

export { DealWigdetSection };
